<template>
  <!-- 这是一个无渲染组件，仅用于管理SEO相关功能 -->
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const route = useRoute();
const { t, locale } = useI18n();

// 网站基础URL
const baseUrl = 'https://whisperherb.com';

// 支持的语言列表
const supportedLocales = ['en', 'zh', 'fr', 'de', 'nl', 'es'];

// 当前页面的完整URL
const currentUrl = computed(() => {
  return `${baseUrl}${route.path}`;
});

// 更新canonical标签
const updateCanonicalTag = () => {
  const canonicalLink = document.getElementById('canonical-link');
  if (canonicalLink) {
    canonicalLink.setAttribute('href', currentUrl.value);
  }
};

// 更新hreflang标签
const updateHreflangTags = () => {
  // 移除现有的动态hreflang标签
  const existingHreflangs = document.querySelectorAll('link[rel="alternate"][hreflang][data-dynamic="true"]');
  existingHreflangs.forEach(tag => tag.remove());
  
  // 为每种支持的语言添加hreflang标签
  supportedLocales.forEach(lang => {
    const hreflangLink = document.createElement('link');
    hreflangLink.rel = 'alternate';
    hreflangLink.hreflang = lang;
    
    // 设置URL（带有语言参数，除了默认语言）
    if (lang === 'en') {
      hreflangLink.href = `${baseUrl}${route.path}`;
    } else {
      hreflangLink.href = `${baseUrl}${route.path}?lang=${lang}`;
    }
    
    hreflangLink.setAttribute('data-dynamic', 'true');
    document.head.appendChild(hreflangLink);
  });
  
  // 添加x-default hreflang标签
  const defaultLink = document.createElement('link');
  defaultLink.rel = 'alternate';
  defaultLink.hreflang = 'x-default';
  defaultLink.href = `${baseUrl}${route.path}`;
  defaultLink.setAttribute('data-dynamic', 'true');
  document.head.appendChild(defaultLink);
};

// 更新语言切换器的URL
const updateLanguageSwitcherUrls = () => {
  // 这里可以添加逻辑来更新语言切换器的URL，确保它们包含当前路径
  // 如果您有一个语言切换器组件，可以通过事件或状态管理来通知它
};

// 更新所有SEO相关标签
const updateAllSeoTags = () => {
  updateCanonicalTag();
  updateHreflangTags();
  updateLanguageSwitcherUrls();
};

// 监听路由和语言变化
watch(
  () => [route.path, locale.value],
  () => {
    updateAllSeoTags();
  }
);

// 组件挂载时更新标签
onMounted(() => {
  updateAllSeoTags();
});
</script>